import React from 'react'

const RequiredIndicator = () => <span style={{ color: 'red' }}>&nbsp;*</span>

export default RequiredIndicator
